<template>
  <div>
    <el-button class="goBack" @click="goBack">返回</el-button>
    <div class="listContent">
      <div class="searchContent">
        <el-button
          icon="el-icon-plus"
          type="danger"
          @click="openAddBox(activeObj)"
          >添加终端</el-button
        >
        <el-button
          type="info"
          @click="deleteSignAll(theCheckObj.equipCode)"
          plain
          >删除</el-button
        >
        <span class="searchInputText">设备编号</span>
        <el-input
          placeholder="请输入设备编号"
          v-model="search.equipCode"
        ></el-input>
        <el-button type="danger" @click="doSearch">查找</el-button>
        <el-button type="info" @click="resetSearch" plain>重置</el-button>
      </div>

      <div class="listContain equipmentList">
        <div class="tablelistBody">
          <el-table
            :data="dataList"
            style="width: 100%"
            size="medium"
            v-loading="listLoading"
            :row-key="fieldKey"
            @selection-change="handleSelectionChange"
            ref="tb"
          >
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column
              prop="equipCode"
              label="设备编号"
              width="300"
            ></el-table-column> 
            <el-table-column
              prop="activateKey"
              label="激活码"
              width="300" 
            ></el-table-column>
            <el-table-column prop="code" label="激活状态" width="280">
              <template slot-scope="scope">
                <span class="lookMore" v-if="scope.row.status == 0"
                  >未激活</span
                >
                <span class="lookMore" v-if="scope.row.status == 1"
                  >已激活</span
                >
                <span class="lookMore" v-if="scope.row.status == 3"
                  >已冻结</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="activateTime"
              label="激活时间"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="createTime"
              label="创建时间"
              width=""
            ></el-table-column>

            <el-table-column label="操作" width>
              <template slot-scope="scope">
                <span v-if="scope.row.status != 3" class="lookMore" @click="freeze(scope.row)">冻结</span>
                <span v-if="scope.row.status != 0" class="lookMore" @click="resetting(scope.row)">重置为未激活</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-pageCover
      class="pageBlock"
      :pageMsg="pageMsg"
      @sizeChange="pageSizeChange"
      @currentChange="currentPageChange"
    ></el-pageCover>

    <el-dialog
      :title="actionName"
      :visible.sync="addModBoxVisible"
      :close-on-click-modal="false"
      width="400px"
    >
      <div class="borderBlock borderPadding addAndEdit">
        <el-form
          :rules="rules"
          :model="modelObj"
          ref="addModForm"
          label-width="100px"
        >
          <el-form-item label="设备编号" required prop="equipCode">
            <el-input
              class="longType"
              v-model="modelObj.equipCode"
              maxlength="20"
              placeholder="请输入设备编号"
            ></el-input>
          </el-form-item>

          <div style="clear: both"></div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addModBoxVisible = false">取消</el-button>
        <el-button type="primary" @click="addModSubmit">{{
          actionName
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  endpointList,
  freezeEndPoint,
  resetEndPoint,
  addEndPoint as addPost,
  delEndPoint as delPut,
  modDept as modPut,
} from "../../utils/api";
import roleMixin from "../../utils/roleMixin";
import mixinList from "../../utils/mixinList";
import ElPageCover from "../../components/overall/ElPageCover";
export default {
  name: "app",
  mixins: [roleMixin, mixinList],
  data() {
    return {
      fieldKey: "equipCode",
      fieldRowName: 'equipCode',
      arrowList: [
        {
          name: "设备中心",
          path: "/transfer/equipmentCenter",
        },
        {
          name: "终端管理",
          path: "",
        },
      ],
      search: {},
      modelObj: {},
      actionName: '',
      treeList: [],
      dataList: [],
      activeObj: '',
      theCheckObj: '',
      userRoleList: localStorage.getItem("userRoleList")
    };
    
  },
  computed: {
    rules: function () {
      return {
        equipCode: [{ required: true, message: "必填" }, { trigger: "blur" }],
        type: [{ required: true, message: "必填" }],
        code: [{ required: true, message: "必填" }, { trigger: "blur" }],
        targetDuration: [
          { required: true, message: "必填" },
          { trigger: "blur" },
        ],
      };
    },
  },
  created() {},
  mounted() {
    this.$store.commit("setArrowList", this.arrowList);
    this.getDataList()
  },
  methods: {
    addPost,
    modPut,
    delPut,
    toInfo: function(e){
      console.log(e)
      // this.$router.push({path:'/transfer/equipmentList',query:{equipCode:e.equipCode,equipCode:e.equipCode}})
    },
    freeze: function(e){
      let params = {
        equipCode: e.equipCode
      }
      this.$confirm(
          "确认对所选记录进行冻结吗?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            dangerouslyUseHTMLString: true
          }
        ).then(() => {
          freezeEndPoint(params).then(()=>{
            this.getDataList()
          })
        })
    },
    resetting: function(e){
      let params = {
        equipCode: e.equipCode
      }
      this.$confirm(
          "确认对所选记录进行重置为未激活吗?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            dangerouslyUseHTMLString: true
          }
        ).then(() => {
          resetEndPoint(params).then(()=>{
            this.getDataList()
          })
        })
    },
    getDataList: function(params) {
      endpointList(params).then(res => {
        console.log(res)
        // let _arr = res.data.content.concat([]);

        // let _getDepts = function(list, _depts) {
        //   for (let i = 0; i < list.length; i++) {
        //     let _m = list[i];
        //     _depts.push({
        //       id: _m.equipCode,
        //       label: _m.equipCode,
        //       originalData: _m
        //     });

        //     if (Object.prototype.hasOwnProperty.call(_m, "children") && _m.children.length > 0) {
        //       _depts[_depts.length - 1].children = [];
        //       _getDepts(_m.children, _depts[_depts.length - 1].children);
        //     }
        //   }
        // };
        // let _depts = [];
        // _getDepts(_arr, _depts);
        // this.treeList = _depts;
        this.dataList = res.data.content.list;
        console.log(this.dataList);
      });
    },
    handleSelectionChange(selection){
      console.log(selection)
      this.theCheckObj = selection[0]
      if(selection.length == 0){
          this.checkedGh = ''
      }else{
          this.checkedGh = selection[0].id;
          this.checkedName = selection[0].sectionName;
          if (selection.length > 1) {
              this.$refs.tb.clearSelection();
              this.$refs.tb.toggleRowSelection(selection.pop());
          }
          
      }
    },
    goBack: function () {
      this.$router.push({ name: 'EquipmentCenter' });
    },
  },
  components: {
    ElPageCover
  },
};
</script>



<style lang="scss" scoped="">
.imgShow {
  height: 950px;
  width: 100%;
  background-image: url("../../images/all/applyImg.png");
  background-size: 100% 100%;
}
.listContent {
  height: 790px;
  width: 98.5%;
  margin: 0 auto;
  background-color: #ffffff;
  .searchContent {
    height: 70px;
    width: 80%;
    padding: 17.5px 17px;
  }
}
.listContain {
  width: 98.5%;
  margin: 0 auto;
}
.lookMore {
  display: inline-block;
  font-size: 14px;
  color: #e24747;
  background: rgba(255, 232, 232, 1);
  border: 1px solid rgba(226, 71, 71, 1);
  border-radius: 16px;
  padding: 4px 16px;
  margin-left: 10px;
  cursor: pointer;
}

.goBack {
  position: fixed;
  right: 16px;
  top: 68px;
  z-index: 1000;
}
</style>